import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { apiUrl } from "@/lib/apiConfig";

const SESSION_KEY = "tfu_session_id";

const getSessionId = () => {
  let sid = sessionStorage.getItem(SESSION_KEY);
  if (!sid) {
    sid = `s_${Date.now()}_${Math.random().toString(36).slice(2, 9)}`;
    sessionStorage.setItem(SESSION_KEY, sid);
  }
  return sid;
};

/**
 * Fires `/api/track/visit` once per pathname change.
 * Skips /admin paths to avoid polluting analytics with internal traffic.
 */
const VisitorTracker = () => {
  const location = useLocation();
  const lastPath = useRef(null);

  // Global promo parameter listener across all storefront pages
  useEffect(() => {
    try {
      if (typeof window !== "undefined" && location.search) {
        const params = new URLSearchParams(location.search);
        const promo = params.get("promo") || params.get("code") || params.get("cupon");
        if (promo) {
          const cleaned = promo.trim().toUpperCase();
          sessionStorage.setItem("tfu_promo", cleaned);
          localStorage.setItem("tfu_promo", cleaned);
        }
      }
    } catch (_) {}
  }, [location.search]);

  useEffect(() => {
    const path = location.pathname;
    if (path.startsWith("/admin")) return;
    if (path === lastPath.current) return;
    lastPath.current = path;

    const sendVisit = () => {
      const session_id = getSessionId();
      const payload = {
        path,
        referrer: document.referrer || "",
        user_agent: navigator.userAgent,
        session_id,
      };
      const beaconUrl = apiUrl("/track/visit");

      if (navigator.sendBeacon) {
        const body = new Blob([JSON.stringify(payload)], { type: "application/json" });
        if (navigator.sendBeacon(beaconUrl, body)) return;
      }
      fetch(beaconUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
        keepalive: true,
      }).catch(() => {});
    };

    const idleId = window.requestIdleCallback
      ? window.requestIdleCallback(sendVisit, { timeout: 2500 })
      : window.setTimeout(sendVisit, 1200);

    return () => {
      if (window.cancelIdleCallback && typeof idleId === "number") window.cancelIdleCallback(idleId);
      else window.clearTimeout(idleId);
    };
  }, [location.pathname]);

  return null;
};

export default VisitorTracker;
